import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const videoLinks = [
    "https://youtu.be/Kq6Dm8Ph9Fg",
    "https://youtu.be/V6hdR53dzvg",
    "https://youtu.be/c8yHGVUlFQs",
    "https://youtu.be/tXjJBWQ0WE4",
    "https://youtu.be/D8W9xd166Vk",
    "https://youtu.be/6Bl8GgiNpjo",
    "https://youtu.be/G7K9Gg-We0g",
    "https://youtu.be/ovJwkeY7F8A",
    "https://youtu.be/Plb-NxuO9Ok",
    "https://youtu.be/q8T9qswUsBE",
    "https://youtu.be/sCZskmZ6YDg",
    "https://youtu.be/E6qX5TY-IVU",
    "https://youtu.be/GcHft1MKV9Q",
    "https://youtu.be/7A0KKDeVze0",
    "https://youtu.be/VC7SeOKC7ts",
    "https://youtu.be/6DW-ke2r8-U",
    "https://youtu.be/hcuQUbx2T2w",
    "https://youtu.be/XcSMcfKS25I",
    "https://youtu.be/JtX3zzgeDA8",
];

function TrainingVideo() {
  const [toggler, setToggler] = useState(false);
  const [activeSource, setActiveSource] = useState(null); 

  const getYouTubeThumbnail = (url) => {
    let videoId = "";
    if (url.includes("youtu.be")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    } else if (url.includes("youtube.com")) {
      videoId = url.split("v=")[1]?.split("&")[0];
    }
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };

  const openLightbox = (index) => {
    const videoUrl = videoLinks[index];
    
    let videoId = "";
    if (videoUrl.includes("youtu.be")) {
      videoId = videoUrl.split("youtu.be/")[1].split("?")[0];
    } else if (videoUrl.includes("youtube.com")) {
      videoId = videoUrl.split("v=")[1]?.split("&")[0];
    }
    
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`; 
    
    // 1. Create a custom iframe wrapped in a responsive container
    const customIframe = (
      <div 
        // 👇 REVISED STYLES: Use 90% width of the screen, center it, and define the 16:9 ratio.
        style={{
          position: 'relative',
          // Sets the overall width to be almost fullscreen (90% of the lightbox window)
          width: '90vw', 
          // Sets the height to maintain 16:9 aspect ratio relative to the 90vw width
          paddingTop: '50.625vw', // (9 / 16) * 90 = 50.625
          margin: '0 auto',
          // The display property can sometimes help enforce the container's size
          display: 'block', 
          marginTop: '30px',
        }}
      >
        <iframe
          referrerPolicy="strict-origin-when-cross-origin" 
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          // The iframe must be absolute to fill the parent div's responsive box
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%', // Fills the 90vw width
            height: '90%', // Fills the calculated height
          }}
        />
      </div>
    );
    
    setActiveSource(customIframe); 
    setToggler(!toggler);
  };

  return (
    <div className="row row--15">
      {videoLinks.map((link, index) => (
        <div className="col-lg-4 col-md-6 col-12 mt--30" key={index}>
          <div className="video-popup icon-center">
            <div className="thumbnail">
              <img
                className="radius-small"
                src={getYouTubeThumbnail(link)}
                alt={`Video ${index + 1}`}
              />
            </div>
            <div className="video-icon">
              <button
                className="btn-default rounded-player"
                onClick={() => openLightbox(index)}
              >
                <span>
                  <FiPlay />
                </span>
              </button>
            </div>
          </div>
        </div>
      ))}

      {activeSource && (
        <FsLightbox toggler={toggler} sources={[activeSource]} />
      )}
    </div>
  );
}

export default TrainingVideo;